import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Divider } from 'base-ui'

import { type FooterTenantLinks } from '../../../config/PerTenantFooterConfiguration.type'

import { FooterShops } from './FooterShops'

type FooterCopyrightAndShopsProps = {
  tenantItemsLinks: FooterTenantLinks
}

export const FooterCopyrightAndShops: FC<FooterCopyrightAndShopsProps> = ({
  tenantItemsLinks,
}) => (
  <div className="container flex flex-col gap-3 py-5 tablet:flex-row tablet:items-center tablet:justify-between tablet:gap-6">
    <Divider className="tablet:hidden" />
    <div className="text-center text-s tablet:text-start">
      {`© 2001 - ${new Date().getFullYear()} `}
      <FormattedMessage id="footer.label.legal" />
    </div>
    <FooterShops tenantLinksItems={tenantItemsLinks} />
  </div>
)
